import * as _ from 'underscore';
import { IWorkbookAccelerationInfo } from '../models/IWorkbookAccelerationInfo';
import { MapperHelper } from './MapperHelper';
import { IView } from '../ServerApi/types/IView';
import { IViewUsageInfo } from '../ServerApi/types/IUsageInfo';
import { IViewAccelerationPerf } from '../ServerApi/types/IViewAccelerationPerf';
import { IViewAccelerationStatus } from '../ServerApi/types/IViewAccelerationStatus';

export module WorkbookAccelerationMapper {

  const M = MapperHelper;

  export function map(
    serverApiViews: IView[],
    usageInfoMaxValues: IViewUsageInfo,
    viewAccelerationPerfs: _.Dictionary<IViewAccelerationPerf> = {},
    viewAccelerationStatus: _.Dictionary<IViewAccelerationStatus> = {}): IWorkbookAccelerationInfo[] {

    return _.map(serverApiViews, (v: IView): IWorkbookAccelerationInfo => {
      return {
        id:                    v.id,
        luid:                  v.luid,
        index:                 M.toNumber(v.index),
        name:                  v.name,
        path:                  v.path,
        usageInfo:             v.usageInfo || <IViewUsageInfo> {},
        usageInfoMaxValues:    usageInfoMaxValues || <IViewUsageInfo> {},
        contentType:           'view',
        speedUp:               viewAccelerationPerfs[v.id] && viewAccelerationPerfs[v.id].speedUp,
        avgNonAcceleratedPLT:  viewAccelerationPerfs[v.id] && viewAccelerationPerfs[v.id].avgNonAcceleratedPLT !== 0 && viewAccelerationPerfs[v.id].avgNonAcceleratedPLT,
        avgAcceleratedPLT:     viewAccelerationPerfs[v.id] && viewAccelerationPerfs[v.id].avgAcceleratedPLT !== 0 && viewAccelerationPerfs[v.id].avgAcceleratedPLT,
        isAccelerated:         viewAccelerationStatus[v.id] && viewAccelerationStatus[v.id].isAccelerated,
        optimizationNotes:     viewAccelerationStatus[v.id] && viewAccelerationStatus[v.id].optimizationNotes,
      };
    });
  }

}
